import { BaseEntity, Entity as DecribeEntity, RelationList } from '@avangard/utils/entity';

import { i18n } from '@lib/i18n';
import { StudentOnlineApplicationDocumentType, SoaDocumentStatus } from '@modules/types/graphql';
import { SoaDocumentFileEntityList } from './soa-document-file.entity-list';

import type { StudentOnlineApplicationDocument } from '@modules/types/graphql';
import type { SoaDocumentFileEntity } from './soa-document-file.entity';

export type Entity = Partial<StudentOnlineApplicationDocument> | null;

@DecribeEntity('SoaDocumentEntity')
class SoaDocumentEntity extends BaseEntity {
    id: string;
    type: StudentOnlineApplicationDocumentType;
    name: string;
    description: string;
    template: string;
    example: string;
    status: SoaDocumentStatus;

    @RelationList(() => SoaDocumentFileEntityList)
    files: SoaDocumentFileEntity[];

    constructor(entity: Entity) {
        super(entity);

        this.id = entity?.id ?? '';
        this.type = entity?.type ?? StudentOnlineApplicationDocumentType.identity;
        this.name = entity?.name ?? '';
        this.description = entity?.description ?? '';
        this.template = entity?.template ?? '';
        this.example = entity?.example ?? '';
        this.status = entity?.status ?? SoaDocumentStatus.pending;
    }

    getStatusTitle() {
        switch (this.status) {
            case SoaDocumentStatus.pending:
                return i18n.t('students:blocks.soa_document_status.pending');

            case SoaDocumentStatus.review:
                return i18n.t('students:blocks.soa_document_status.review');

            case SoaDocumentStatus.correction:
                return i18n.t('students:blocks.soa_document_status.correction');

            case SoaDocumentStatus.approved:
                return i18n.t('students:blocks.soa_document_status.approved');
        }
    }

    getFilesWithRef() {
        return this.files.filter(file => file.documentRef);
    }

    hasFiles() {
        return this.files.some(item => item.file.exists());
    }

    hasFilesWithRef() {
        return this.getFilesWithRef().length > 0;
    }

    isPairFilesAsSingle() {
        return this.type === StudentOnlineApplicationDocumentType.certificate_079_086;
    }

    isAllFilesUploaded() {
        return this.files.every(item => item.file.exists());
    }
}

export { SoaDocumentEntity };
